var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTechSignup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6666 10.5H2.33331M16.3333 20.4167L19.25 17.5L16.3333 14.5833M11.6666 14.5833L8.74998 17.5L11.6666 20.4167M2.33331 9.1L2.33331 18.9C2.33331 20.8602 2.33331 21.8403 2.71479 22.589C3.05035 23.2475 3.58578 23.783 4.24435 24.1185C4.99304 24.5 5.97313 24.5 7.93331 24.5H20.0666C22.0268 24.5 23.0069 24.5 23.7556 24.1185C24.4142 23.783 24.9496 23.2475 25.2852 22.589C25.6666 21.8403 25.6666 20.8602 25.6666 18.9V9.1C25.6666 7.13982 25.6666 6.15973 25.2852 5.41103C24.9496 4.75247 24.4142 4.21704 23.7556 3.88148C23.0069 3.5 22.0268 3.5 20.0666 3.5L7.93331 3.5C5.97313 3.5 4.99304 3.5 4.24435 3.88148C3.58578 4.21703 3.05035 4.75247 2.71479 5.41103C2.33331 6.15972 2.33331 7.13982 2.33331 9.1Z",
    stroke: "#414651",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechSignup);
export default __webpack_public_path__ + "static/media/techSignup.8bf55fd64c0ead81732ddb1f5f85a1fb.svg";
export { ForwardRef as ReactComponent };